













































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import ProposalUserReport from "@/models/porposal/porposalUserReport.model";
import GenericEdit from "@/core/Generics/GenericEdit";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import fileService from "@/services/file.service";
import BudgetExpenseService from "@/services/budgetExpense.service";
import ProposalUserReportService from "@/services/proposalUserReport.service";
import ProposalBudgetItemExecution from "@/models/porposal/proposalBudgetItemExecution.model";
import ProposalBudgetSubItemExecution from "@/models/porposal/proposalBudgetSubItemExecution.model";
import { Utils } from "@/core/Utils";
import ProposalBudgetSubItemExecutionDocument from "../../models/porposal/proposalBudgetSubItemExecutionDocument.model";
import ProposalScheduleGanttPhase from "../../models/porposal/proposalScheduleGanttPhase.model";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import { ProposalState } from "@/enums/ProposalState";

@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    DatePickerComponent,
    GantCharttComponent
  }
})
export default class ViewReport extends GenericEdit<ProposalUserReport> {
  budgetExpenses = [];
  budgetExpenseService = new BudgetExpenseService();
  completeAndSend = false;
  files = [];
  proposalUserReportService: ProposalUserReportService = new ProposalUserReportService();
  proposalScheduleGanttPhases: Array<ProposalScheduleGanttPhase> = [];
  aprobadaFc = ProposalState.AprobadoFC;
  constructor() {
    super();
    this.controller = "PorposalUserReport";
    this.model = new ProposalUserReport();
  }

  onComplete() {}

  protected async getData() {
    try {
      this.loading = true;
      this.model = await this.repository.byId(this.id, this.include);

      if (this.model.startPeriod)
        this.model.startPeriod = new Date(this.model.startPeriod);
      if (this.model.endPeriod)
        this.model.endPeriod = new Date(this.model.endPeriod);

      let gantChart = await this.proposalUserReportService.getByEvaluacionType(
        this.model.proposalHistoricPercentDoneScheduleGanttId,
        this.model.proposalId
      );
      let lastGanttHistory = gantChart.proposalHistoricPercentDoneScheduleGantt;
      for (let i = 0; i < gantChart.proposalScheduleGanttPhases.length; i++) {
        const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
          x =>
            x.proposalScheduleGanttPhaseId ==
            gantChart.proposalScheduleGanttPhases[i].id
        );
        gantChart.proposalScheduleGanttPhases[i].percentDone =
          phase.percentDone;
        gantChart.proposalScheduleGanttPhases[i].percentDoneUI =
          phase.percentDone;
        for (
          let j = 0;
          j <
          gantChart.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities.length;
          j++
        ) {
          const activity = phase.proposalHistoricActivitiesPercentDone.find(
            x =>
              x.proposalScheduleGanttActivityId ==
              gantChart.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].id
          );
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDone =
            activity.percentDone;
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDoneUI =
            activity.percentDone;
        }
      }
      this.proposalScheduleGanttPhases = gantChart.proposalScheduleGanttPhases;
      this.getBudgetExpenses();
    } catch (errors) {
      
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }
  async verDocument(data: any = null) {
    if (data.isLastResport) {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
      //
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }

  calculateTotalAmountSpentByBudgetExpense(
    rows: Array<ProposalBudgetItemExecution>
  ) {
    return rows.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }
  calculateTotalSpentByBudgetItem(row: ProposalBudgetItemExecution) {
    return row.proposalBudgetSubItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  async downloadFile(file: any) {
    if (file.document.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        file.document.id,
        file.document.originalName
      );
    else await fileService.download(file.document.id);
  }

  get totalSpent() {
    return this.model.proposalBudgetItemsExecution.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }

  cleanObject(sendObject: ProposalUserReport) {
    sendObject.document = null;
    sendObject.porposalBudgetItems = [];
    sendObject.proposal = null;
    sendObject.researchCenter = null;

    for (let i = 0; i < sendObject.proposalBudgetItemsExecution.length; i++) {
      const item = sendObject.proposalBudgetItemsExecution[i];
      item.porposalBudgetItem = null;
      for (let y = 0; y < item.proposalBudgetSubItemsExecution.length; y++) {
        const sub = item.proposalBudgetSubItemsExecution[y];
        sub.porposalBudgetSubItem = null;
      }
    }
  }
}
